// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { DomQuery, WithClass } from "./Dom";
import { WebPageComponent } from "./WebSite.Page.Component";

export class ConsentWindow extends WebPageComponent {
  constructor(element) {
    super(element);

    this.determineElements();
    this.attachHandlers();
  }

  attachHandlers() {
    this.button.onclick = (event) => { this.consent(); };
  }

  consent() {
    const request = new XMLHttpRequest();

    const formData = new FormData();
    formData.append("Consent", true);

    request.open("POST", this.element.dataset.Uri, true);
    request.onload = () => {
      window.location = this.element.dataset.Uri;
    };
    request.send(formData);
  }

  determineElements() {
    this.button = new DomQuery(this.element).getChild(WithClass("Consent"));
  }
}

interactivityRegistration.register("ConsentWindow", function (element) { return new ConsentWindow(element); });
